import { all, takeLatest } from 'redux-saga/effects'
import service from '../../services/confirm.service'
import { actions } from './Confirm.state'

function callConfirmCallback () {
  service.state.onConfirm()
}

export default function * effects () {
  yield all([
    takeLatest(actions.confirm, callConfirmCallback)
  ])
}
